module.exports = __webpack_public_path__ + "img/accueil-moonly-app-symptothermie-suivi-cycle-ovulation-medium.4da5a7de.png";